import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement } from "chart.js";
import "./donutChartBig.css";

Chart.register(ArcElement);

const DonutChartBig = ({ title }) => {
  const data = {
    labels: ["Completed Projects", "Incomplete Projects"],
    datasets: [
      {
        label: "# of Votes",
        data: [65, 35],
        backgroundColor: ["#4C5A9F", "#A2ADE9"],
        borderColor: ["#4C5A9F", "#A2ADE9"],
        borderWidth: 1,
      },
    ],
  };
  const options = {
    cutout: "65%",
    responsive: true,
    plugins: {
      tooltip: {
        enabled: true, // <-- this option disables tooltips
      },
      legend: {
        display: false, // Hide the legend
      },
    },
  };

  const balls = [
    {
      label: "Completed Projects",
      value: 65,
      color: "#4C5A9F",
    },
    {
      label: "Incomplete Projects",
      value: 35,
      color: "#A2ADE9",
    }
  ];

  return (
    <div className="pvxDonutBig">
      <div className="head">
        <div className="text">{title}</div>
        <img
          src="./images/PvxDashboard/Icons/Dots.svg"
          className="dots"
          alt="Dots"
        />
      </div>
      <div className="chart">
        <Doughnut data={data} options={options} />
      </div>
      <div className="balls">
        {balls.map((ball, index) => (
          <div className="data" key={index}>
            <div
              className="ball"
              style={{ backgroundColor: ball.color }}
            ></div>
            <div className="label">
              <span className="text">{ball.label}</span>
              <span className="value">{ball.value}%</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DonutChartBig;
